import React, { useEffect } from 'react';
import { Modal, Icon, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
    fetchCommunicationProgram,
    fetchCommunicationProgramFilter,
    clearCommunicationProgram,
    comunicationProgramDiffusionClear,
    clearcommunicationProgramFilter,
    comunicationProgramCourseClear,
    comunicationProgramCourseAvailableClear,
} from 'app/actions/CommunicationProgramActions';
import { categoryAvailableClear } from 'app/actions/CategoryAvailableActions';
import {
    getCommunicationProgram,
    getCommunicationProgramFilter,
    getIsLoadingCommunicationProgram
} from 'app/reducers';
import IconButton from '@material-ui/core/IconButton';
import ApiService from 'app/services/ApiService';
import { setTimeout } from 'timers';
import isEmpty from 'app/utils/IsEmpty';
import { employeeById } from 'app/reducers';
import { getTrainingSelect } from "app/actions/TrainingActions";
import { getExternalEmployees } from 'app/actions/CommunicationProgramActions';
import { courseAvailableClear } from 'app/actions/CourseAvailableActions';

export default function CommunicationProgramsContainer(props) {
    const { classes } = props;
    const { confirm } = Modal;

    const { trainingSelect } = useSelector(state => state.TrainingReducer)

    const {
        idSubdirection,
        employeeId
    } = useSelector(state => state.Auth.employeeById)

    const {
        siteId
    } = useSelector(state => state.Auth)

    const {
        Roles
    } = useSelector(state => state.Auth.item.User);

    const roleAllowed = () => {
        for (const rol of Roles) {
            if (rol.NameRole.includes('Supervisor de aseguramiento de calidad'))
                return true;
        }
        return false;
    }



    const pagination = props.pagination;
    const sorter = props.sorter;
    let offset = 0;
    let limit = 25;
    let column = '';
    let order = '';

    const columns = [
        {
            title: 'Folio',
            dataIndex: 'cpFolio',
            key: 'cpFolio',
            sorter: true,
            width: 150
        },
        {
            title: 'Nombre',
            dataIndex: 'communicationProgramName',
            key: 'communicationProgramName',
            sorter: true,
            width: 300,
            ellipsis: true
        },
        {
            title: 'Descripción',
            dataIndex: 'communicationProgramDescription',
            key: 'communicationProgramDescription',
            sorter: true,
            width: 300,
            ellipsis: true
        },
        {
            title: 'Tipo Capacitación',
            dataIndex: 'trainingName',
            key: 'trainingName',
            sorter: true,
            width: 200,
            ellipsis: true,
            render: (training) => (
                training === null ? "N/A" : training
            )

        },
        {
            title: 'Difusiones',
            dataIndex: 'isConfigured',
            key: 'isConfigured',
            sorter: true,
            className: 'alignCenter',
            width: 120,
            render: (hasConfigured) => (
                hasConfigured ? <Icon type="check-circle" style={{ fontSize: '20px', color: '#5CBF69' }} /> : <Icon type="warning" style={{ fontSize: '20px', color: '#FFD600' }} />
            )
        },
        {
            title: 'Fecha de creación',
            dataIndex: 'creationDate',
            key: 'creationDate',
            sorter: true,
            className: 'alignCenter',
            width: 160,
            render: record => new Date(record).toLocaleDateString()
        },
        {
            title: 'Fecha modificación',
            dataIndex: 'modificationDate',
            key: 'modificationDate',
            sorter: true,
            className: 'alignCenter',
            width: 160,
            render: record => new Date(record).toLocaleDateString()
        },
        {
            title: 'Estatus',
            dataIndex: 'statusName',
            key: 'statusName',
            sorter: true,
            width: 100
        },
        {

        },
        {
            title: 'Acciones',
            key: 'action',
            dataIndex: 'idCommunicationProgram',
            fixed: 'right',
            width: siteId === 'HUB' ? 170 : 80,
            render: (text, record) => (
                <div className={classes.buttons}>
                    {
                        siteId === 'HUB' ?
                            <Tooltip placement="bottom" title={'Elimnar'}>
                                <IconButton className={classes.deleteIcon} onClick={() => showConfirmDelete(record)} disabled={record.statusName === 'ASIGNADO'}>
                                    <Icon type="delete" />
                                </IconButton>
                            </Tooltip> : null
                    }
                    <Tooltip placement="bottom" title={siteId === 'HUB' || (siteId !== 'HUB' && roleAllowed() === true) ? 'Editar' : 'Visualizar'}>
                        <IconButton className={classes.editIcon} onClick={() => showTabEdit(record)}>
                            <Icon type={siteId === 'HUB' || (siteId !== 'HUB' && roleAllowed() === true)  ? "edit" : "eye"} />
                        </IconButton>
                    </Tooltip>
                    {
                        siteId === 'HUB' ?
                            <Tooltip placement="bottom" title={'Baja/Suspesión'}>
                                <IconButton className={classes.editIcon} onClick={() => showConfirmSuspended(record)} disabled={record.deleted === -1}>
                                    <Icon type="poweroff" />
                                </IconButton>
                            </Tooltip> : null
                    }

                </div>
            )
        }
    ];

    const showTabEdit = (param) => {
        dispatch(getExternalEmployees());
        dispatch(courseAvailableClear());
        props.setIdCommunicationProgram(param.idCommunicationProgram);
        dispatch(comunicationProgramDiffusionClear());
        dispatch(clearcommunicationProgramFilter());
        dispatch(fetchCommunicationProgramFilter({ idSubdirection: idSubdirection,idEmployee: employeeId }));
        dispatch(comunicationProgramCourseClear());
        dispatch(comunicationProgramCourseAvailableClear());
        dispatch(categoryAvailableClear());
        props.setTab('3');
    }

    const showConfirmDelete = (param) => {
        confirm({
            title: '¿Eliminar Programa de Comunicación?',
            content: param.communicationProgramName,
            okText: 'Eliminar',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                confirm({
                    title: 'Confirmación de eliminación de PDC',
                    content: `Está acción elimina toda la información  (sin importar estus) relacionada al programa de comunicación "${param.communicationProgramName}"`,
                    okText: 'Eliminar',
                    okType: 'danger',
                    cancelText: 'Cancelar',
                    onOk() {
                        dispatch(clearcommunicationProgramFilter());
                        dispatch(fetchCommunicationProgramFilter({ idSubdirection: idSubdirection,idEmployee: employeeId }));
                        return deleteCommunicationPrograms(param.idCommunicationProgram);
                    },
                    onCancel() { },
                });
            },
            onCancel() { },
        });

    }

    const showConfirmSuspended = (param) => {
        confirm({
            title: '¿Asignar Baja/Suspensión al Programa de Comunicación?',
            content: param.communicationProgramName,
            okText: 'Baja/Suspensión',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                dispatch(clearcommunicationProgramFilter());
                dispatch(fetchCommunicationProgramFilter({ idSubdirection: idSubdirection,idEmployee: employeeId }));
                return suspendCommunicationPrograms(param.idCommunicationProgram);
            },
            onCancel() { },
        });

    }

    async function deleteCommunicationPrograms(id) {
        await ApiService.deleteCommunicationProgram(id).then(res => {
            dispatch(clearCommunicationProgram());
            dispatch(fetchCommunicationProgram({ ...props.formData, idSubdirection: idSubdirection, idEmployee: employeeId }));
            const modal = Modal.success({
                title: `Eliminado Correctamente`,
                content: '',
            });

            setTimeout(function () {
                modal.destroy();
            }, 3000)

        });
    }

    async function suspendCommunicationPrograms(id) {
        await ApiService.suspendCommunicationProgram(id).then(res => {
            dispatch(clearCommunicationProgram());
            dispatch(fetchCommunicationProgram({ ...props.formData, idSubdirection: idSubdirection,idEmployee: employeeId }));
            const modal = Modal.success({
                title: `Baja/Suspensión Aplicada Correctamente`,
                content: '',
            });

            setTimeout(function () {
                modal.destroy();
            }, 3000)
        });
    }

    let communicationProgram = useSelector(getCommunicationProgram);
    let communicationProgramFilter = useSelector(getCommunicationProgramFilter);

    let isLoading = useSelector(getIsLoadingCommunicationProgram);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isEmpty(communicationProgram)) fetchCommunicationProgramAction();
        if (isEmpty(communicationProgramFilter)) fetchCommunicationProgramFilterAction();
        if (isEmpty(trainingSelect)) fetchTrainingSelect();
    }, []);

    const fetchTrainingSelect = () => dispatch(getTrainingSelect(employeeId));

    const handleTableChange = (pagination, filters, sorter) => {

        props.setPagination(pagination);
        props.setSorter(sorter);
        if (Object.keys(sorter).length > 0) {
            column = sorter.field;
            order = sorter.order === "ascend" ? "ASC" : "DESC";
        }
        else {
            column = '';
            order = '';
        }
        dispatch(fetchCommunicationProgram(
            {
                CommunicationProgramFolio: (props.formData.CommunicationProgramFolio === undefined) ? '' : props.formData.CommunicationProgramFolio,
                CommunicationProgramName: (props.formData.CommunicationProgramName === undefined) ? '' : props.formData.CommunicationProgramName,
                CommunicationProgramDescription: (props.formData.CommunicationProgramDescription === undefined) ? '' : props.formData.CommunicationProgramDescription,
                StatusName: (props.formData.StatusName === undefined) ? '' : props.formData.StatusName,
                idSubdirection: idSubdirection,
                Contract: (props.formData.Contract === undefined) ? '' : props.formData.Contract,
                Work: (props.formData.Work === undefined) ? '' : props.formData.Work,
                trainings: (props.formData.trainings === undefined) ? '' : props.formData.trainings,
                InitialCreationDate: (props.formData.InitialCreationDate === undefined) ? '' : props.formData.InitialCreationDate,
                FinalCreationDate: (props.formData.FinalCreationDate === undefined) ? '' : props.formData.FinalCreationDate,
                InitialRevDate: (props.formData.InitialRevDate === undefined) ? '' : props.formData.InitialRevDate,
                FinalRevDate: (props.formData.FinalRevDate === undefined) ? '' : props.formData.FinalRevDate,
                NotSuspended: (props.formData.NotSuspended === undefined) ? false : props.formData.NotSuspended,
                sortColumn: column,
                sortDir: order,
                offset: ((pagination.current - 1) * pagination.pageSize),
                limit: pagination.pageSize,
                idEmployee: employeeId
            }));
    };

    //Load
    if (pagination != null) {
        offset = (0 * pagination.pageSize);
        limit = (pagination.pageSize);

        if (!isLoading && communicationProgram.length > 0) {
            pagination.total = communicationProgram[0].totalcount;
        }
        else {
            pagination.total = 0;
        }
    }

    if (sorter != null) {
        column = sorter.field;
        order = sorter.order === "ascend" ? "ASC" : "DESC";
    }



    const fetchCommunicationProgramAction = () => dispatch(fetchCommunicationProgram({
        sortColumn: 'IdCommunicationProgram',
        sortDir: 'DESC',
        offset: offset,
        limit: limit,
        idSubdirection: idSubdirection,
        idEmployee: employeeId
    }));
    const fetchCommunicationProgramFilterAction = () => dispatch(fetchCommunicationProgramFilter({ idSubdirection: idSubdirection,idEmployee: employeeId }))
    const filterParam = communicationProgram.find(function (element) {
        return element.idCommunicationProgram === props.idCommunicationProgram;
    });
    return (props.children({ pagination: pagination, cols: columns, filterParam, communicationProgram, communicationProgramFilter, isLoading, handleTableChange: handleTableChange }));
}


